import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { MissionPage } from './pages/MissionPage';
function useHashRoute() {
  const getRoute = () => window.location.hash;
  const [hash, setHash] = useState(getRoute);
  useEffect(() => {
    const handler = () => setHash(getRoute());
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);
  return hash;
}
function useSEO() {
  useEffect(() => {
    // Page title
    document.title = 'Meelo — ERP система для детских садов в Казахстане';
    // Helper to set or create a meta tag
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Meta description
    setMeta('name', 'description', 'Meelo — система управления детским садом. Циклограммы, меню, журналы, склад, документы и аналитика в одной платформе. Подключение за 2 дня.');
    // Open Graph
    setMeta('property', 'og:title', 'Meelo — ERP система для детских садов');
    setMeta('property', 'og:description', 'Автоматизируйте управление детским садом: меню, циклограммы, документы, финансы и аналитика.');
    setMeta('property', 'og:site_name', 'Meelo');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/bsudF3ForJPFx5q9LjRTna/final_logo_(1).svg');
    // Favicon via link tag
    const setFavicon = (href: string) => {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.type = 'image/svg+xml';
      link.href = href;
    };
    setFavicon('https://cdn.magicpatterns.com/uploads/bsudF3ForJPFx5q9LjRTna/final_logo_(1).svg');
  }, []);
}
export function App() {
  const hash = useHashRoute();
  useSEO();
  if (hash === '#/mission') return <MissionPage data-id="element-0" />;
  return <LandingPage data-id="element-1" />;
}